//#region src/common/replace-www-for-hosts.ts
var e = (e) => e.replace(/^www\./, "");
//#endregion
export { e as replaceWwwForHosts };
